/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit PaymentsPostPayment/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import Content from './Content/index'
import Empty from './Empty/index'
import Error from './Error/index'
import Loading from './Loading/index'
import No from './No/index'
import PaymentProvider from 'DesignSystem/PaymentProvider/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function PaymentsPostPayment({
  children,
  viewPath = "/App/Account/EmbeddableCoreMessageListener/PaymentsPostPayment"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'No'
let globalCurrentLocationXidValueData = fromData.useDataValue({ viewPath,
context: 'global',
path: 'current_location.xid',
})
  return (<React.Fragment
>
<PaymentProvider
  viewPath={`${viewPath}/PaymentProvider`}
 allowLocationChoice={true}
 data="global.current_location.xid"
 xid={globalCurrentLocationXidValueData}
 viewPath={viewPath}
>
{childProps => (
<React.Fragment>
<fromFlow.When is={flowValue === 'No'}>
<No
{...childProps}
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Loading'}>
<Loading
{...childProps}
  viewPath={`${viewPath}/Loading`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Error'}>
<Error
{...childProps}
  viewPath={`${viewPath}/Error`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Empty'}>
<Empty
{...childProps}
  viewPath={`${viewPath}/Empty`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Content'}>
<Content
{...childProps}
  viewPath={`${viewPath}/Content`}
/>
</fromFlow.When>
</React.Fragment>
)}
</PaymentProvider>
{children}
</React.Fragment>)
}